import NotExistsContent from '@/feat-components/error/NotExistsContent';
import React from 'react';

const NotExistsCotentPage = () => {
  return <NotExistsContent />;
};

export default NotExistsCotentPage;
